var _path, _rect, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPieChartBlocked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 282,
    viewBox: "0 0 282 282",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M281 141C281 218.32 218.32 281 141 281C63.6801 281 1 218.32 1 141C1 63.6801 63.6801 1 141 1C218.32 1 281 63.6801 281 141ZM29 141C29 202.856 79.1441 253 141 253C202.856 253 253 202.856 253 141C253 79.1441 202.856 29 141 29C79.1441 29 29 79.1441 29 141Z",
    stroke: "#D5DCE0",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 130.6,
    y: 139.8,
    width: 16.8,
    height: 10.8,
    rx: 1,
    stroke: "#D5DCE0",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M139 143.4V147",
    stroke: "#D5DCE0",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134.2 139.8V135C134.2 132.349 136.349 130.2 139 130.2C141.651 130.2 143.8 132.349 143.8 135V139.8",
    stroke: "#D5DCE0",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChartBlocked);
export default __webpack_public_path__ + "static/media/pie-chart-blocked.e8d67cb813c1a3c3fe2eb3e4e6ecbfec.svg";
export { ForwardRef as ReactComponent };